import { useState } from "react";
import { toast } from "sonner";
import api, { formatApiError } from "../api";
import { useT } from "../i18n";
import { inputCls } from "./PasswordInput";

export default function ForgotPasswordForm() {
  const { t } = useT();
  const [open, setOpen] = useState(false);
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (err) { toast.error(formatApiError(err)); }
    finally { setLoading(false); }
  };

  return (
    <div className="mt-4">
      <button type="button" data-testid="forgot-password-link" onClick={() => { setOpen(!open); setSent(false); }}
        className="text-sm font-semibold text-[#0D4045] underline underline-offset-2 hover:text-[#0a3237] transition-colors duration-200">
        {t("login.forgot")}
      </button>
      {open && (
        sent ? (
          <p data-testid="forgot-sent-msg" className="mt-3 text-sm font-semibold text-[#065F46] bg-[#D1FAE5] border border-[#34D399]/50 rounded-xl px-4 py-3">
            {t("login.forgot.sent")}
          </p>
        ) : (
          <form onSubmit={submit} className="flex gap-2 mt-3" data-testid="forgot-form">
            <input data-testid="forgot-email-input" type="email" required placeholder={t("login.email")}
              value={email} onChange={(e) => setEmail(e.target.value)} className={inputCls + " flex-1"} />
            <button type="submit" disabled={loading} data-testid="forgot-submit-btn"
              className="px-5 min-h-[48px] bg-[#E8F3F1] text-[#0D4045] text-sm font-semibold rounded-full hover:bg-[#d7eae6] transition-colors duration-200 disabled:opacity-60">
              {t("login.forgot.submit")}
            </button>
          </form>
        )
      )}
    </div>
  );
}
